import { render } from "./IRRSingleScatter.vue?vue&type=template&id=69f463e0"
import script from "./IRRSingleScatter.vue?vue&type=script&lang=js"
export * from "./IRRSingleScatter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__